"use client";

import { useMemo } from "react";
import useTranslations from "@/i18n/useTranslations";

export function useFooterMessages() {
  const t = useTranslations("Footer");

  return useMemo(
    () => ({
      logoAlt: t("logoAlt"),
      logoTitle: t("logoTitle"),
      copyright: (year: number) => t("copyright", { year }),
      appStoreAlt: t("appStoreAlt"),
      appStoreTitle: t("appStoreTitle"),
      googlePlayAlt: t("googlePlayAlt"),
      googlePlayTitle: t("googlePlayTitle"),
      socialFacebook: t("socialFacebook"),
      socialX: t("socialX"),
      socialLinkedIn: t("socialLinkedIn"),
      socialReddit: t("socialReddit"),
      sectionConnect: t("sectionConnect"),
      sectionLegal: t("sectionLegal"),
      about: t("about"),
      edxForBusiness: t("edxForBusiness"),
      affiliates: t("affiliates"),
      openEdx: t("openEdx"),
      careers: t("careers"),
      news: t("news"),
      ideaHub: t("ideaHub"),
      contactUs: t("contactUs"),
      helpCenter: t("helpCenter"),
      security: t("security"),
      mediaKit: t("mediaKit"),
      termsOfService: t("termsOfService"),
      privacyPolicy: t("privacyPolicy"),
      cookiePolicy: t("cookiePolicy"),
      accessibilityPolicy: t("accessibilityPolicy"),
      trademarkPolicy: t("trademarkPolicy"),
      modernSlavery: t("modernSlavery"),
      sitemap: t("sitemap"),
      yourPrivacyChoices: t("yourPrivacyChoices"),
    }),
    [t],
  );
}
